{
  "name": "@zskarte/app",
  "version": "6.0.2",
  "engines": {
    "node": ">=20"
  },
  "scripts": {
    "ng:serve": "ng serve --port 4300 --host 0.0.0.0",
    "ng:serve:dev": "ng serve --port 4300 --host 0.0.0.0 --configuration development",
    "ng:serve:prod": "ng serve --port 4300 --host 0.0.0.0 --configuration production",
    "ng:serve:e2e": "npm-run-all -p ng:serve:dev wait",
    "ngsw:update": "node scripts/update-ngsw-config.js",
    "ng:build:prod": "npm run ngsw:update && ng build --configuration production",
    "ng:build:dev": "npm run ngsw:update && ng build --configuration development",
    "build": "run-p ng:build:prod",
    "start": "run-p ng:serve",
    "start:dev": "run-p ng:serve:dev",
    "test:e2e": "playwright test",
    "test": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.6",
    "@angular/cdk": "^21.0.5",
    "@angular/common": "^21.0.6",
    "@angular/compiler": "^21.0.6",
    "@angular/core": "^21.0.6",
    "@angular/forms": "^21.0.6",
    "@angular/material": "^21.0.5",
    "@angular/platform-browser": "^21.0.6",
    "@angular/platform-browser-dynamic": "^21.0.6",
    "@angular/pwa": "^21.0.4",
    "@angular/router": "^21.0.6",
    "@angular/service-worker": "^21.0.6",
    "@pdfme/common": "^5.5.8",
    "@pdfme/generator": "^5.5.8",
    "@pdfme/schemas": "^5.5.8",
    "@pdfme/ui": "^5.5.8",
    "@types/file-saver": "^2.0.7",
    "@types/geojson": "^7946.0.16",
    "@zskarte/common": "file:../common",
    "@zskarte/types": "file:../types",
    "angular-split": "^20.0.0",
    "dexie": "^4.2.1",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "html2canvas": "^1.4.1",
    "immer": "^10.2.0",
    "jspdf": "^3.0.4",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.21",
    "luxon": "^3.7.2",
    "material-icons": "^1.13.14",
    "ngx-indexed-db": "^19.4.3",
    "ngx-quill": "^30.0.1",
    "ol-ext": "^4.0.37",
    "ol-mapbox-style": "^12.6.1",
    "ol-pmtiles": "^2.0.2",
    "proj4": "^2.20.2",
    "qrcode": "^1.5.4",
    "quill": "^2.0.3",
    "rxjs": "~7.8.2",
    "shpjs": "^6.2.0",
    "socket.io": "^4.8.3",
    "socket.io-client": "^4.8.3",
    "ts-md5": "^1.3.1",
    "tslib": "^2.8.1",
    "uuid": "^11.1.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@analogjs/vite-plugin-angular": "^2.3.1",
    "@analogjs/vitest-angular": "^2.3.1",
    "@angular-devkit/build-angular": "^21.0.4",
    "@angular/cli": "~21.0.4",
    "@angular/compiler-cli": "^21.0.6",
    "@playwright/test": "^1.57.0",
    "@testing-library/angular": "^19.1.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@types/jasmine": "~5.1.5",
    "@types/lodash": "^4.17.21",
    "@types/luxon": "^3.7.1",
    "@types/ol-ext": "npm:@siedlerchr/types-ol-ext@^3.6.5",
    "@types/proj4": "^2.5.6",
    "@types/qrcode": "^1.5.6",
    "@types/uuid": "^10.0.0",
    "@vitest/coverage-v8": "^4.1.0",
    "jsdom": "^29.0.0",
    "npm-run-all": "^4.1.5",
    "typescript": "~5.9.3",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.1.0",
    "wait-on": "^8.0.5"
  }
}
